<template>
  <div id="left-bar" v-if="showLeftBar()" :class="this.$mq">
    <transition name="fade">
      <div id="loading" v-if="loading" class="z4">
        <p class="m2"><loader></loader></p>
      </div>
    </transition>
    <div id="upper" v-if="!showSearch">
      <ol id="channels" class="m0 p0 pl2 pt3" v-scroll-to="'#menu'">
        <li v-for="channel in channels" :key="channel.id">
          <router-link :to='channelLink(channel)'>{{ channel.name }}</router-link>
        </li>
      </ol>
    </div>

    <transition name="slide-fade">
      <div id="search-bar" v-if="showSearch" class="col col-12 md-col-6">
        <input id="search-input" type="text" v-model="searchTerm" class="pl2" v-autofocus @keyup.enter="startSearch(searchTerm)" placeholder="Enter search term and press enter..." autocomplete="off">
        <div id="close-search"><router-link :to="'/videos' + this.$route.hash"><img src="../assets/close.svg" /></router-link></div>
      </div>
    </transition>

    <main-menu></main-menu>

    <router-view name="content" :searchTerm="searchTerm"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MainMenu from '@/components/MainMenu'
import Loader from '@/components/Loader'

export default {

  name: 'LeftBar',

  data () {
    return {
      searchTerm: ''
    }
  },

  components: {
    MainMenu,
    Loader
  },

  computed: {
    ...mapState([
      'channels',
      'videos',
      'themes',
      'searchResults'
    ]),
    showSearch: function () {
      return (this.$route.name === 'Search' || this.$route.name === 'Related')
    },
    loading: function () {
      return !(this.channels && this.videos && this.themes)
    }
  },

  mounted: function () {
    this.setChannelHeight()
  },

  methods: {
    ...mapActions([
      'getChannels',
      'getVideos',
      'getThemes',
      'getAllThemes',
      'search',
      'getRelated'
    ]),
    startSearch: function (term) {
      this.$router.push('/search/' + term + this.$route.hash)
      this.scrollToVideos()
      this.search(term)
    },
    channelLink: function (channel) {
      return '/channels/' + channel.slug + this.$route.hash
    },
    showLeftBar: function () {
      this.setChannelHeight()
      return this.$route.name !== 'Live'
    },
    getRelatedVideos: function () {
      if (this.videos !== null) {
        if (this.$route.params.relatedSlug) {
          let videoID = this.videos.find(video => {
            return video.slug === this.$route.params.relatedSlug
          })
          this.getRelated(videoID.id)
        }
      }
    },
    setChannelHeight () {
      this.$nextTick().then(() => {
        if (document.getElementById('channels')) {
          let minHeight = `calc(${window.innerHeight - document.getElementById('menu').offsetHeight}px - 2rem)`
          document.getElementById('channels').style.minHeight = minHeight
        }
      })
    },
    setSearchTerms () {
      if (this.$route.params.searchTerm) {
        let term = this.$route.params.searchTerm
        this.searchTerm = term
        this.search(term)
      }

      if (this.$route.params.relatedSlug) {
        let slug = this.$route.params.relatedSlug
        this.searchTerm = `Related to '${slug}'`
      }
    }
  },

  created: function () {
    this.getVideos().then(() => {
      this.getRelatedVideos()
    })
    this.getChannels()
    this.getThemes()
    this.getAllThemes()
    this.setSearchTerms()
  },

  watch: {
    $route (to, from) {
      this.setSearchTerms()
      if (to.name === 'Search') {
        document.getElementById('left-bar').scrollIntoView()
      } else if (to.name === 'Related') {
        this.getRelatedVideos()
      } else if (from.name !== 'Live' && to.hash === from.hash) {
        this.scrollToVideos()
      }
    },
    searchTerm: function () {
      this.$Lazyload.lazyLoadHandler()
    },
    showSearch: function () {
      console.log(this.showSearch)
      if (!this.showSearch) {
        this.setChannelHeight()
      }
    }
  }
}
</script>

<style lang="css" scoped>
#loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 50vw;
  color: var(--color-green);
  background: var(--color-black);
}

#left-bar {
  z-index: 100;
  position: relative;
  background: var(--color-black);
  color: var(--color-light);
  width: 50vw;
  border-right: 1px solid var(--color-green);

  &.sm, &.md {
    width: 100vw;
    border-right: 0;
  }
}

#channels {
  font-family: "IBM Plex Sans", "Helvetica Neue", sans-serif;
  font-weight: 300;
  /*min-height: calc(100vh - 6rem);*/
  font-size: 4vw;
  list-style: none;

  li {
    counter-increment: custom;

    &:before {
      content: counter(custom) " ";
      margin-right: 0.25em;
    }

    &:first-child {
      counter-reset: custom;
    }
  }
}

#search-bar {
  position: fixed;
  top: 0;
  left: 0;
  background: var(--color-black);
  z-index: 10100;
  transition: top 0.25s ease-out;

  #close-search {
    position: absolute;
    top: 24px;
    right: 2em;
    color: var(--color-green);

    img {
      width: 16px;
    }
  }
}

#search-input {
  font-size: var(--font-size-large);
  width: calc(100% - 1.3em);
  background: none;
  color: var(--color-green);
  border: none;
  border-bottom: 1px solid var(--color-green);
  height: 61px;

  &:focus {
    outline: none;
  }
}

@media only screen and (max-width: 40em) {
  #upper {
    height: 75vh;
  }
  #channels {
    font-size: 9vw;
    padding-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LeftBar.vue